import { Card, IconButton, darken, styled } from '@mui/material';
import type { CardProps } from '@mui/material';

export const StyledCard = styled(Card)<CardProps>(() => ({
  borderRadius: '20px',
  width: '330px',
  height: '360px',
  margin: 'auto',
  position: 'relative',
}));

export const CardPrimaryIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.main,
  borderRadius: '4px',
  width: '36px',
  height: '36px',
  boxShadow:
    '0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.1)',
  '&:hover': {
    backgroundColor: darken(theme.palette.primary.main, 0.2),
  },
}));

export const CardPlatformContainer = styled('div')(({ theme }) => ({
  borderRadius: '4px',
  borderColor: theme.palette.grey[200],
  borderWidth: '1px',
  borderStyle: 'solid',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

export const CardPlatformScoreContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px',
}));
